import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HttpClientModule } from '@angular/common/http';
import { ProfileComponent } from './profile/profile.component';
import { HomeComponent } from './home/home.component';
import { AuthorizeComponent } from './authorize/authorize.component';
import { OrganizationUsersComponent } from './organization-users/organization-users.component';
import { OrganizationUserComponent } from './organization-user/organization-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_INITIALIZER } from '@angular/core';

// Material
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { DynamicFormComponent } from './dynamic-forms/dynamic-form.component';
import { DynamicFormQuestionComponent } from './dynamic-forms/dynamic-form-question.component';
import { DynamicFormDialogComponent } from './dynamic-forms/dynamic-form-dialog.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClientsComponent } from './clients/clients.component';
import { ConfigurationService } from './configuration.service';
import { PageHeadingComponent } from './components/page-heading/page-heading.component';
import { SmallCardButtonComponent } from './components/small-card-button/small-card-button.component';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { AccountPhotoComponent } from './components/account-photo/account-photo.component';
import { LogoutComponent } from './logout/logout.component';
import { CreateOrganisationComponent } from './components/create-organisation/create-organisation.component';
import { CreateOrganisationModalComponent } from './modals/create-organisation-modal/create-organisation-modal.component';
import { CreateWorkspaceComponent } from './components/create-workspace/create-workspace.component';
import { TermsCondtionsComponent } from './components/terms-condtions/terms-condtions.component';
import { WorkspaceInvitationComponent } from './components/workspace-invitation/workspace-invitation.component';
import { DisabledWorkspaceDialogComponent } from './modals/disabled-workspace-dialog/disabled-workspace-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ProfileComponent,
    HomeComponent,
    AuthorizeComponent,

    OrganizationUsersComponent,
    OrganizationUserComponent,
    DynamicFormComponent,
    DynamicFormQuestionComponent,
    DynamicFormDialogComponent,
    ClientsComponent,
    PageHeadingComponent,
    CreateOrganisationComponent,
    SmallCardButtonComponent,
    EllipsisPipe,
    AccountPhotoComponent,
    LogoutComponent,
    CreateOrganisationModalComponent,
    CreateWorkspaceComponent,
    TermsCondtionsComponent,
    WorkspaceInvitationComponent,
    DisabledWorkspaceDialogComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    // Material
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSnackBarModule,
    MatTabsModule,
    MatSelectModule,
    MatListModule,
    MatRadioModule,
    MatDialogModule,
    MatCardModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatCheckboxModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: resourceProviderFactory,
      deps: [ConfigurationService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function resourceProviderFactory(provider: ConfigurationService) {
  return () => provider.loadConfiguration();
}
